import React, { useEffect } from 'react';
import { lockBodyScroll } from '../utils/scrollLock';

// 全屏图片放大查看器. 点击背景 / 按 Esc 关闭.
// 用法: const [zoomSrc, setZoomSrc] = useState<string | null>(null);
//        <ImageLightbox src={zoomSrc} alt="..." onClose={() => setZoomSrc(null)} />
//        <img src={url} onClick={() => setZoomSrc(url)} />

interface Props {
    src: string | null;
    alt?: string;
    onClose: () => void;
}

function ImageLightbox({ src, alt, onClose }: Props) {
    useEffect(() => {
        if (!src) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        // 锁滚动 (引用计数, 见 utils/scrollLock)
        const unlock = lockBodyScroll();
        return () => {
            document.removeEventListener('keydown', onKey);
            unlock();
        };
    }, [src, onClose]);

    if (!src) return null;

    return (
        <div
            className="fixed inset-0 !m-0 z-[9999] flex items-center justify-center bg-black/85 cursor-zoom-out"
            onClick={onClose}
        >
            <button
                type="button"
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 text-white hover:bg-white/20 text-xl"
                onClick={onClose}
                aria-label="关闭"
            >
                ×
            </button>
            <img
                src={src}
                alt={alt || 'preview'}
                className="max-w-[92vw] max-h-[92vh] object-contain shadow-2xl"
                onClick={(e) => e.stopPropagation()}
            />
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/70 text-xs">
                点击空白处或按 Esc 关闭
            </div>
        </div>
    );
}

export default ImageLightbox;
